module.exports = __webpack_public_path__ + "img/2022.2.省委办公厅.d24f01d2.png";